import { produce } from 'immer'
import { compact, forEach, map, remove } from 'lodash'
import { ShipOrderData } from '../apis/shipOrder.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    shipOrders: ShipOrderData[]
  ): TableHorizontalData<ShipOrderData>[] {
    forEach(shipOrders, (shipOrder: TableHorizontalData<ShipOrderData>) => {
      const actions: ActionName[] = ['view', 'scan', 'edit']
      if (!shipOrder.isDeleted) actions.push('delete')
      shipOrder.actions = actions
    })
    return shipOrders
  },

  searchOptions (shipOrders: ShipOrderData[]) {
    const shipOrdersData = map(shipOrders, shipOrder => {
      const { code, id } = shipOrder
      return { id, value: code }
    })
    return compact(shipOrdersData)
  },

  delete (shipOrders: TableHorizontalData<ShipOrderData>[], id: number) {
    return produce(shipOrders, shipOrders => {
      remove(shipOrders, { id })
    })
  }
}
